var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoles1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "1.9 1.9 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.50016H12.35C12 1.5335 11.0833 0.833496 10 0.833496C8.91667 0.833496 8 1.5335 7.65 2.50016H4.16667C3.25 2.50016 2.5 3.25016 2.5 4.16683V15.8335C2.5 16.7502 3.25 17.5002 4.16667 17.5002H15.8333C16.75 17.5002 17.5 16.7502 17.5 15.8335V4.16683C17.5 3.25016 16.75 2.50016 15.8333 2.50016ZM10 2.50016C10.4583 2.50016 10.8333 2.87516 10.8333 3.3335C10.8333 3.79183 10.4583 4.16683 10 4.16683C9.54167 4.16683 9.16667 3.79183 9.16667 3.3335C9.16667 2.87516 9.54167 2.50016 10 2.50016ZM10 5.8335C11.3833 5.8335 12.5 6.95016 12.5 8.3335C12.5 9.71683 11.3833 10.8335 10 10.8335C8.61667 10.8335 7.5 9.71683 7.5 8.3335C7.5 6.95016 8.61667 5.8335 10 5.8335ZM15 15.8335H5V14.6668C5 13.0002 8.33333 12.0835 10 12.0835C11.6667 12.0835 15 13.0002 15 14.6668V15.8335Z",
    fill: "#545963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles1);
export default __webpack_public_path__ + "static/media/roles_1.b8a94a87c13336ec4eab3ce6297e7b8e.svg";
export { ForwardRef as ReactComponent };